export default "__VITE_ASSET__zwFnyYN8__"